import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, finalize, Observable, Subject, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import moment from 'moment';

import { handleError, fechaYymmdd } from './utils';
import { Articulo } from '../models/articulo.model';
import { jsonMapReplacer, jsonMapReviver, Usuario } from '../models/usuario.model';
import { Pedido, PedidoLineas, PedidoLinea, IncidCab, IncidLin } from '../models/pedido.model';
import { ArticuloService } from './articulo.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { StorageService } from './storage.service';
import { ArtFiltroResp } from '../models/art-filtro.model';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {

  private SERVER_URL = environment.SERVER_PED_URL;
  // SERVER_AUTH deprecated - se usa Bearer token desde localStorage

  public usuario: Usuario | undefined;
  public usuarios: Usuario[] = [];
  public paramPedido: Parametro;
  public paramLista: Parametro;
  public cestaAnimationStatus = 'initial';
  public listaAnimationStatus = 'initial';
  public pedido: Pedido | undefined;
  public pedidoLista: Pedido | undefined;
  public lista: Articulo[] = [];
  public cesta: Articulo[] = [];
  public listaLineas: PedidoLinea[] = [];
  public cestaLineas: PedidoLinea[] = [];
  public totalCesta = 0;
  public nuevosPrecios: any = [];
  public enviando = false;
  public procesando = false;
  private totalizaSubject = new Subject<string>();
  public isCab: boolean = true;
  public pedidoNota: string = '';

  // Observable que se puede compartir
  public totalizaObservable$ = this.totalizaSubject.asObservable();
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private toastr: ToastrService,
    private articuloService: ArticuloService,
    private storageService: StorageService,
    public router: Router,

  ) {
    this.paramPedido = this.nuevoParametro();
    this.paramLista = this.nuevoParametro();

  }

  public inicializaParametrosUsu(consultarTodo = true) {
    const stored = this.storageService.getItem('usuario_model');
    this.usuario = stored ? JSON.parse(stored) : undefined;
    const pedccId = (this.usuario == undefined) ? '' : (this.usuario.pedcc_id == null) ? '' : this.usuario.pedcc_id.toString();
    const listaId = (this.usuario == undefined) ? '' : (this.usuario.pedcc_lista_id == null) ? '' : this.usuario.pedcc_lista_id.toString();
    if (this.articuloService.parametros == null) {
      this.articuloService.reseteaParametros();
    }
    this.articuloService.parametros.alm_id = ((this.usuario == undefined) || (this.usuario!.alm_id == undefined)) ? '' : this.usuario!.alm_id!.toString();
    this.articuloService.parametros.cli_id = ((this.usuario == undefined) || (this.usuario!.cli_id == undefined)) ? '' : this.usuario!.cli_id!.toString();
    if (this.usuario != undefined && this.usuario.tarc_id !== null) {
      this.articuloService.parametros.tar_id = ((this.usuario == undefined) || (this.usuario!.tarc_id == undefined)) ? '' : this.usuario.tarc_id!.toString();
    }
    this.articuloService.parametros.pedcc_id = pedccId;
    this.articuloService.parametros.pedcc_lista_id = listaId;

    this.paramPedido.pedcc_id = pedccId;
    this.paramPedido.cli_id = ((this.usuario == null) || (this.usuario!.cli_id == undefined)) ? '' : this.usuario!.cli_id!.toString();

    this.paramLista.pedcc_id = listaId;
    this.paramLista.cli_id = ((this.usuario == null) || (this.usuario!.cli_id == undefined)) ? '' : this.usuario!.cli_id!.toString();
    if (consultarTodo) {
      this.articuloService.reseteaParametros();
      this.getAll();
    }
  }

  public getAll() {
    this.getPedido().subscribe({
      next: res => {
        console.log('Pedido recibido:', res);
      },
      error: err => {
        console.error('Error al obtener pedido:', err);
      }
    });
    this.getPedidoArticulos();
    this.getLista().subscribe({
      next: (res) => {
        console.log('Pedido lista recibido:', res);
      },
      error: (err) => {
        console.error('Error al obtener la lista de pedidos:', err);
      }
    });

    this.getListaArticulos();
    this.articuloService.getArticulos();
    this.articuloService.getAllSectores().subscribe();
    this.articuloService.getSecciones();
    this.articuloService.getArtFiltros().subscribe({
      next: (res) => {
        this.articuloService.artFiltroResp = res;

        if (res.items.length > 0) {
          res.items[0].art_filtro.forEach(item => {
            if (item.tipo === 'RADIO') {
              item.valor_filtro = item.valores[0]?.codigo ?? '';
            }
          });
        }
      }
    });;
  }

  grabaUsuario(consultarTodo = false) {
    this.storageService.setItem('usuario_model', JSON.stringify(this.usuario, jsonMapReplacer));
    this.inicializaParametrosUsu(consultarTodo);
  }

  // Métodos para Incidencias (Por ahora el GET no es necesario)
  // GET
  public getIncid(id: number, isCab: boolean) {
    const idType = isCab ? 'pedcc_id' : 'pedcl_id';
    let url = this.SERVER_URL + (isCab ? 'incidenciaCab?' : 'incidenciaLin?') + idType + id;
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
      })
    });

  }
  public consultaIncidencia(id: number, isCab: boolean, art: Articulo) {
    this.articuloService.articulo = art;
    this.getIncid(id, isCab)!.subscribe({
      next: (res: any) => {
        const resultado = res;
        console.log(resultado.incid_id);
        if (isCab) {
          this.pedidoNota = resultado.notas;
          this.pedido!.notas = this.pedidoNota;
          this.pedido!.incid_id = resultado.incid_id;
        } else {
          this.articuloService.articulo!.pedcl_notas = resultado.notas;
          this.articuloService.articulo!.pedcl_incid_id = resultado.incid_id;
        }
      },
      error: (err) => this.handleErrorAux(err, true)
    });
  }
  //POST

  public postIncid(notas: String, id: number, isCab: boolean) {
    const idType = isCab ? 'pedcc_id' : 'pedcl_id';
    const body = {
      [idType]: id,
      notas: notas
    };

    if (id != null && notas != null && notas.trim() !== "") {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN
          ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN')
          : ''
      });

      return this.http.post(this.SERVER_URL + '/incidencia', body, { headers });
    } else {
      return;
    }
  }

  public createIncidencia(notas: String, id: number, isCab: boolean, art?: Articulo) {
    this.articuloService.articulo = art;
    this.postIncid(notas, id, isCab)!.subscribe({
      next: (res: any) => {
        const resultado = res;
        console.log(resultado.notas);
        if (isCab) {
          this.pedidoNota = resultado.notas;
          this.pedido!.notas = this.pedidoNota;
          this.pedido!.incid_id = resultado.incidId;
        } else {
          this.articuloService.articulo!.pedcl_notas = resultado.notas;
          this.articuloService.articulo!.pedcl_incid_id = resultado.incidId;
        }
      },
      error: (err) => this.handleErrorAux(err, true)
    });
  }
  //PUT
  public putIncidencia(incidId: number, notas: String) {
    const body = {
      notas: notas
    };

    if (incidId != null && notas != null && notas.trim() !== "") {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN
          ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN')
          : ''
      });
      const url = this.SERVER_URL + '/incidencia?incid_id=' + incidId;
      return this.http.put(url, body, { headers });
    } else {
      return;
    }
  }
  public updateIncidencia(incidId: number, notas: String, isCab: boolean, art?: Articulo) {
    if (art != null || art != undefined)
      this.articuloService.articulo = art;
    if (incidId != undefined && incidId != null && notas != null && notas != "") {
      this.putIncidencia(incidId, notas)!.subscribe({
        next: (res: any) => {
          const resultado = res;
          console.log(resultado.notas);
          if (isCab) {
            this.pedidoNota = resultado.notas;
          } else {
            this.articuloService.articulo!.pedcl_notas = resultado.notas;
            this.articuloService.articulo!.pedcl_incid_id = resultado.incidId;
          }
        },
        error: (err) => this.handleErrorAux(err, true)
      });
    }
  }
  //DELETE
  public deleteIncid(incidId: number) {
    let url = this.SERVER_URL + '/incidencia?incid_id=';
    if (incidId != undefined && incidId != null) {
      url = url + incidId.toString();
      return this.http.delete(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
        })
      });
    } else {
      return;
    }
  }
  public deleteIncidencia(incidId: number, isCab: boolean) {
    if (incidId != undefined && incidId != null) {
      this.deleteIncid(incidId)!.subscribe({
        next: (res: any) => {
          const resultado = res;
          console.log(resultado)
          if (isCab) {
            this.pedidoNota = '';
            this.pedido!.notas = '';
            this.pedido!.incid_id = null;
          } else {
            this.articuloService.articulo!.pedcl_notas = '';
            this.articuloService.articulo!.pedcl_incid_id = null;
          }
        },
        error: (err) => this.handleErrorAux(err, true)
      });
    }
  }


  enviaPedido(pedido: Pedido, pagoPasarela: boolean = false): void {
    pedido.estado = 'A';
    this.controlFechaServicio(pedido);
    this.usuarios = localStorage.getItem('usuarios_model')
      ? JSON.parse(localStorage.getItem('usuarios_model')!)
      : null;

    this.putPedido(pedido, pagoPasarela).subscribe({
      next: (res: any) => {
        this.pedido = undefined;
        this.cesta = [];
        if (this.usuario != undefined) {
          this.usuario!.pedcc_id = -1; // Vaciar pedido
          if (this.usuarios != undefined && this.usuarios != null) {
            for (let i = 0; i < this.usuarios.length; i++) {
              if (this.usuario?.cli_id == this.usuarios[i].cli_id) {
                this.usuarios[i] = this.usuario;
              }
            }
          }
        }

        this.storageService.setItem('usuarios_model', JSON.stringify(this.usuarios, jsonMapReplacer));
        this.grabaUsuario(true);
        this.getPedido().subscribe({
          next: res => {
            console.log('Pedido recibido:', res);
          },
          error: err => {
            console.error('Error al obtener pedido:', err);
          }
        });
        this.getPedidoArticulos();
      },
      error: (err) => this.handleErrorAux(err, true),
      complete: () => this.toastr.info('Pedido finalizado')
    });
  }

  controlFechaServicio(pedido: Pedido): void {
    const hoy: Date = new Date();
    const fsM = moment(hoy);
    let fechaServicio = pedido?.fecha_servicio;

    if (!fechaServicio && this.usuario != null && this.usuario.dias_servicio) {
      // Fecha inicial sumando días de servicio
      fechaServicio = moment(fsM).add(this.usuario.dias_servicio, 'days').toDate();

      // Revisar hora de corte
      const fechaMoment = moment(fechaServicio);
      const hora = fechaMoment.hour();
      const min = fechaMoment.minute();
      const horaActual = `${hora}:${min.toString().padStart(2, '0')}`;

      if (horaActual > this.usuario.hora_corte) {
        // Si pasa de la hora de corte, sumar un día más
        fechaServicio = fechaMoment.add(1, 'days').toDate();
      }

      // Asignar la fecha final calculada
      pedido.fecha_servicio = fechaServicio;
    }
  }

  borraPedido(pedido: Pedido) {
    this.deletePedido(pedido).subscribe(
      (res: any) => {
        this.pedido = undefined;
        this.cesta = [];
        if (this.usuario != undefined)
          this.usuario.pedcc_id = -1;
        this.grabaUsuario(true);
        this.totalizaSubject.next('consulta');
      },
      err => this.handleErrorAux(err, true),
      () => {
        this.toastr.info('Pedido borrado');
      }
    );
  }
  enviaListaPedido() {
    let enviados = 0;
    this.cesta.forEach(articulo => {
      if (articulo.lista_pedcl_id === null) {
        enviados++;
        this.sumaLista(articulo);
      }
    });
    return enviados;
  }
  sumaLista(articulo: Articulo) {
    const index = this.lista.findIndex(x => x.art_id === articulo.art_id);
    if (index === -1) {
      articulo.lista_cant_ped = 1;
      this.postListaLinea(articulo);
    } else {
      articulo.lista_cant_ped = 0;
      this.postListaLinea(articulo);
    }
  }
  cambiarCantidadCesta(articulo: Articulo, cant: number) {
    if (this.enviando === false) {
      const pedcl_cant_ped_ori = articulo.pedcl_cant_ped;
      if (!this.controlStock(articulo, cant)) {
        return;
      }
      if (articulo.pedcl_cant_ped > 0) {
        if (!this.controlKilosMinimo(articulo)) {
          return;
        }
      }
      this.enviando = true;
      this.cestaAnimationStatus = 'final';
      if (articulo.pedcl_cant_ped === pedcl_cant_ped_ori) {
        // solo incrementa si controlKilosMinimo no ha cambiado la cantidad
        articulo.pedcl_cant_ped = cant;
      }
      if (articulo.pedcl_div_costo_cli === null) {
        this.tb(articulo, environment.TIPO_BULTO_DEF);
      }
      this.precioCesta(articulo);
      const index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      if (index === -1) {
        if (articulo.pedcl_tb_ped === null) {
          this.tb(articulo, environment.TIPO_BULTO_DEF);
        }
      }
      this.postCestaLinea(articulo);
      this.totalizaCesta();
    }

  }
  sumaCesta(articulo: Articulo) {
    if (this.enviando === false) {
      const pedcl_cant_ped_ori = articulo.pedcl_cant_ped;
      if (!this.controlStock(articulo, ((articulo.pedcl_cant_ped == null) ? 0 : articulo.pedcl_cant_ped) + 1)) {
        return;
      }
      if (articulo.pedcl_cant_ped > 0) {
        if (!this.controlKilosMinimo(articulo)) {
          return;
        }
      }
      this.enviando = true;
      this.cestaAnimationStatus = 'final';
      if (articulo.pedcl_cant_ped === pedcl_cant_ped_ori) {
        // solo incrementa si controlKilosMinimo no ha cambiado la cantidad
        articulo.pedcl_cant_ped++;
      }
      if (articulo.pedcl_div_costo_cli === null && articulo.pedcl_tb_ped === null) {
        this.tb(articulo, environment.TIPO_BULTO_DEF);
      }
      this.precioCesta(articulo);
      const index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      if (index === -1) {
        if (articulo.pedcl_tb_ped === null) {
          this.tb(articulo, environment.TIPO_BULTO_DEF);
        }
      }
      this.postCestaLinea(articulo);
      this.totalizaCesta();
    }

  }
  tbCesta(articulo: Articulo) {
    this.cestaAnimationStatus = 'final';
    if (articulo.pedcl_cant_ped === 0) {
      articulo.pedcl_cant_ped = 1;
    }
    this.controlKilosMinimo(articulo);
    if (articulo.pedcl_div_costo_cli === null) {
      this.tb(articulo, environment.TIPO_BULTO_DEF);
    }
    this.precioCesta(articulo);
    const index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
    if (index === -1) {
      if (articulo.pedcl_tb_ped === null) {
        this.tb(articulo, environment.TIPO_BULTO_DEF);
      }
    }
    this.postCestaLinea(articulo);
    this.totalizaCesta();
  }
  precioCesta(articulo: Articulo) {
    // if (articulo.pedcl_pedcl_id !== null) {
    //   return;
    // }
    articulo.pedcl_div_costo_cli = (articulo.pvp_of_sin_iva === null && articulo.pvp_sin_iva != null) ? articulo.pvp_sin_iva! : articulo.pvp_of_sin_iva!;
    if (articulo.pvp_esp !== null) {
      articulo.pedcl_div_costo_cli = articulo.pvp_esp;
    }
    if (articulo.pedcl_div_costo_cli !== articulo.pvp_of_sin_iva
      && articulo.pedcl_div_costo_cli !== articulo.pvp_esp
      && articulo.pvp_caja_sin_iva !== null
      && (articulo.pedcl_cant_ped * articulo.pedcl_unb_ped) >= articulo.unid_caja) {
      articulo.pedcl_div_costo_cli = articulo.pvp_caja_sin_iva;
    } else if (articulo.pedcl_div_costo_cli !== articulo.pvp_of_sin_iva
      && articulo.pedcl_div_costo_cli !== articulo.pvp_esp
      && articulo.pvp_sin_iva !== null
      && (articulo.pedcl_cant_ped * articulo.pedcl_unb_ped) < articulo.unid_caja) {
      articulo.pedcl_div_costo_cli = articulo.pvp_sin_iva;
    }


    articulo.pedcl_pvp_cliente = (articulo.pvp_of_con_iva === null && articulo.pvp_con_iva != null) ? articulo.pvp_con_iva! : articulo.pvp_of_con_iva!;
    if (articulo.pvp_esp !== null) {
      articulo.pedcl_pvp_cliente = articulo.pvp_esp;
    }
    if (articulo.pedcl_pvp_cliente !== articulo.pvp_of_con_iva
      && articulo.pedcl_pvp_cliente !== articulo.pvp_esp
      && articulo.pvp_caja_con_iva !== null
      && (articulo.pedcl_cant_ped * articulo.pedcl_unb_ped) >= articulo.unid_caja) {
      articulo.pedcl_pvp_cliente = articulo.pvp_caja_con_iva;
    } else if (articulo.pedcl_pvp_cliente !== articulo.pvp_of_con_iva
      && articulo.pedcl_pvp_cliente !== articulo.pvp_esp
      && articulo.pvp_con_iva !== null
      && (articulo.pedcl_cant_ped * articulo.pedcl_unb_ped) < articulo.unid_caja) {
      articulo.pedcl_pvp_cliente = articulo.pvp_con_iva;
    }
  }
  borraCesta(articulo: Articulo, tipo: string = '') {
    // parametro tipo: cesta|shop|checkout: para saber que lista provoca la acción.
    // de momento no se usa
    if (this.enviando === false) {
      this.enviando = true;
      this.cestaAnimationStatus = 'final';
      articulo.pedcl_cant_ped = 0;
      this.tb(articulo, environment.TIPO_BULTO_DEF);
      const index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      this.postCestaLinea(articulo);
      this.totalizaCesta();
    }
  }
  restaCesta(articulo: Articulo) {
    if (this.enviando === false) {
      this.enviando = true;
      this.cestaAnimationStatus = 'final';
      articulo.pedcl_cant_ped--;
      if (articulo.pedcl_cant_ped > 0) {
        this.controlKilosMinimo(articulo);
      }
      if (articulo.pedcl_cant_ped > 0) {
        this.precioCesta(articulo);
      } else {
        articulo.pedcl_div_costo_cli = 0;
        this.tb(articulo, environment.TIPO_BULTO_DEF);
      }
      const index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      this.postCestaLinea(articulo);
      this.totalizaCesta();
    }
  }
  tb(articulo: Articulo, tb: string) {
    articulo.pedcl_tb_ped = tb;
    if (tb === 'C') {
      articulo.pedcl_unb_ped = articulo.unid_caja;
    } else if (tb === 'F') {
      articulo.pedcl_unb_ped = articulo.unid_frac;
    } else if (tb === 'U') {
      articulo.pedcl_unb_ped = 1;
    }
  }
  /*
  * controlKilosMinimo: previene pedir por debajo de los kilos_min
  */
  controlKilosMinimo(articulo: Articulo, avisar: boolean = true) {
    if (articulo.pedcl_tb_ped === 'K') {
      if (articulo.kilos_min !== null && articulo.kilos_min > 0 && articulo.pedcl_cant_ped < articulo.kilos_min) {
        articulo.pedcl_cant_ped = articulo.kilos_min;
        if (avisar) {
          this.toastr.info('Producto con control de kilos mínimo. Debe pedir un minímo de ' + articulo.kilos_min + ' kilos', 'Control Kilos',
            { positionClass: 'toast-top-center', closeButton: true, progressBar: true, timeOut: 5000 });
          // return false;
        }
      }
    }
    return true;
  }
  /*
  * controlStock: devuelve true si se puede comprar
  */
  controlStock(articulo: Articulo, cantComprar: number) {
    if (environment.COMPRAR_SIN_STOCK === 'P') {
      if (articulo.pedcl_unb_ped == null) {
        if (articulo.pedcl_tb_ped === 'C') {
          articulo.pedcl_unb_ped = articulo.unid_caja;
        } else if (articulo.pedcl_tb_ped === 'F') {
          articulo.pedcl_unb_ped = articulo.unid_frac;
        } else {
          articulo.pedcl_unb_ped = 1;
        }
      }
      const unid = cantComprar * articulo.pedcl_unb_ped;
      const unidPeso = (articulo.peso_unid == null) ? 0 : articulo.peso_unid * unid;
      if (articulo.art_peso === 'S' && articulo.pedcl_tb_ped === 'K') {
        // busco stock en kilos para los kilos introducidos por el cliente
        if (articulo.stock_kil != null && cantComprar > articulo.stock_kil) {
          this.toastr.warning('Actualmente no disponemos de stock en este producto.', 'Control Stock',
            { positionClass: 'toast-top-full-width', closeButton: true, progressBar: true, timeOut: 3000 });
          return false;
        }
      } else if (articulo.art_peso === 'S') {
        // busco stock en kilos para el peso medio de las unidades pedidas por el cliente
        if (articulo.stock_kil != null && articulo.peso_unid != null && unidPeso + articulo.peso_unid > articulo.stock_kil) {
          this.toastr.warning('Actualmente no disponemos de stock en este producto.', 'Control Stock',
            { positionClass: 'toast-top-full-width', closeButton: true, progressBar: true, timeOut: 3000 });
          return false;
        }
      } else {
        if (unid > articulo.stock_uni) {
          this.toastr.warning('Actualmente no disponemos de stock en este producto.', 'Control Stock',
            { positionClass: 'toast-top-full-width', closeButton: true, progressBar: true, timeOut: 3000 });
          return false;
        }
      }

    }
    return true;
  }
  copiaPedidoPedcc(pedido: Pedido, nuevo: Pedido) {
    pedido.referencias = nuevo.referencias;
    pedido.fecha_estado = nuevo.fecha_estado;
    pedido.imp_fac_neto = nuevo.imp_fac_neto;
    pedido.imp_fac_total = nuevo.imp_fac_total;
    pedido.lineas = nuevo.lineas;
    pedido.ofertas = nuevo.ofertas;
    pedido.descuentos = nuevo.descuentos;
    pedido.impuestos = nuevo.impuestos;
  }
  copiaArticuloPedcl(articulo: Articulo, nuevo: Articulo) {
    articulo.pedcl_cant_ped = nuevo.pedcl_cant_ped;
    articulo.pedcl_div_costo_cli = nuevo.pedcl_div_costo_cli;
    articulo.pedcl_div_ctocli_dll = nuevo.pedcl_div_ctocli_dll;
    articulo.pedcl_div_ctocli_nl = nuevo.pedcl_div_ctocli_nl;
    articulo.pedcl_ofer_id = nuevo.pedcl_ofer_id;
    articulo.pedcl_fecha_estado = nuevo.pedcl_fecha_estado;
    articulo.pedcl_imp_final_linea = nuevo.pedcl_imp_final_linea;
    if (nuevo.pedcl_cant_ped > 0) {
      articulo.pedcl_pedcc_id = nuevo.pedcl_pedcc_id;
      articulo.pedcl_pedcl_id = nuevo.pedcl_pedcl_id;
    } else {
      articulo.pedcl_pedcc_id = -1;
      articulo.pedcl_pedcl_id = -1;
    }
    articulo.pedcl_tb_ped = nuevo.pedcl_tb_ped;
    articulo.pedcl_unb_ped = nuevo.pedcl_unb_ped;

    articulo.lista_cant_ped = nuevo.lista_cant_ped;
    articulo.lista_fecha_estado = nuevo.lista_fecha_estado;
    articulo.lista_pedcc_id = nuevo.lista_pedcc_id;
    articulo.lista_pedcl_id = nuevo.lista_pedcl_id;
  }
  copiaArticuloLista(articulo: Articulo, nuevo: Articulo) {
    articulo.lista_cant_ped = nuevo.lista_cant_ped;
    articulo.lista_fecha_estado = nuevo.lista_fecha_estado;
    articulo.lista_pedcc_id = nuevo.lista_pedcc_id;
    articulo.lista_pedcl_id = nuevo.lista_pedcl_id;
  }
  pedidoImpPortes() {
    if (this.usuario != undefined && this.usuario.portes) {
      if (this.usuario.imp_portes > 0) {
        if (this.pedido != undefined && this.pedido.imp_fac_total != undefined && this.usuario.ped_min_portes > this.pedido.imp_fac_total) {
          this.pedido.imp_portes = this.usuario.imp_portes;
        } else if (this.pedido != undefined && this.usuario.ped_min_portes === 0 || this.usuario.ped_min_portes === null) {
          this.pedido!.imp_portes = this.usuario.imp_portes;
        } else if (this.pedido != undefined) {
          this.pedido.imp_portes = 0;
        }
      }
    }
  }
  totalizaCesta() {
    // this.totalizaSubject.next('consulta');
    return;
    this.totalCesta = 0;
    this.cesta.forEach(articulo => {
      // articulo.pedcl_imp_final_linea =  Math.round(articulo.pedcl_cant_ped * articulo.pedcl_div_costo_cli * 100) / 100;
      this.totalCesta += articulo.pedcl_imp_final_linea;
    });
    this.totalCesta = Math.round(this.totalCesta * 100) / 100;
  }
  public postPedido(pedido: Pedido) {
    const url = this.SERVER_URL + '/pedido';
    return this.http.post(url,
      pedido, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
        // Authorization''
      })
    });
  }
  public putPedido(pedido: Pedido, pagoPasarela: boolean = false) {
    const url = this.SERVER_URL + '/pedido';
    return this.http.put(url,
      pedido, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
      }),
      params: pagoPasarela ? { pago_pasarela: 'true' } : {}
    });
  }
  public deletePedido(pedido: Pedido) {
    // const httpParams = new HttpParams().set('pedcc_id', pedido.pedcc_id.toString());
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
      // Authorization''
    });
    const options = {
      headers: httpHeaders,
      body: {
        pedcc_id: pedido.pedcc_id != undefined ? pedido.pedcc_id!.toString() : '-1'
      }
    };

    const url = this.SERVER_URL + '/pedido/' + pedido.pedcc_id;
    return this.http.delete(url, options);
  }
  public putCambioPrecio(pedido: Pedido) {
    const url = this.SERVER_URL + '/cambioprecio';
    return this.http.put(url,
      pedido, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
        // Authorization''
      })
    });
  }
  public postCestaLinea(articulo: Articulo) {
    const url = this.SERVER_URL + '/pedlineas';

    if (this.pedido === undefined) {
      this.pedido = {
        pedcc_id: null,
        cli_id: parseInt(this.paramPedido.cli_id, 10),
        alm_id: this.storageService.getItem('alm_id') != null ? parseInt(this.storageService.getItem('alm_id')!, 10) : -1,
        estado: 'W',
        tar_id: null,
        codigo: null,
        sucursal: null,
        razon_social: null,
        nom_comerc: null,
        dir_etiqueta: null,
        cod_postal: null,
        pobl_id: null,
        titulo: null,
        fecha_pedido: null,
        fecha_alta: null,
        fecha_estado: null,
        fecha_precios: null,
        fecha_servicio: null,
        referencias: null,
        bultos: null,
        imp_fac_neto: null,
        imp_fac_total: null,
        notas: null,
        descuentos: [],
        ofertas: [],
        impuestos: [],
        lineas: [],
        imp_portes: 0,
        incid_id: null
      };

      this.postPedido(this.pedido).subscribe({
        next: (res: any) => {
          if (res.error === 'false') {
            const resultado = res.resultado[0];
            this.pedido = resultado; // Spring format
            this.pedidoImpPortes();
            if (this.usuario?.pedcc_id !== undefined) {
              this.usuario.pedcc_id = this.pedido!.pedcc_id!;
              this.grabaUsuario();
            }
          } else {
            this.enviando = false;
          }
        },
        error: (err) => {
          this.handleErrorAux(err, true);
          this.enviando = false;

        },
        complete: () => {
          this.postCestaLinea(articulo); // Reintenta con pedido ya creado
        }
      });

    } else {
      if (articulo.pedcl_pedcc_id == null || articulo.pedcl_pedcc_id == -1) {
        articulo.pedcl_pedcc_id = this.pedido.pedcc_id!;
      }
      articulo.lista = 'false';

      this.posCestaLineaReq(articulo).subscribe({
        next: (res: any) => {
          const resultado = res[0]; // Spring format
          this.copiaPedidoPedcc(this.pedido!, resultado);
          this.pedidoImpPortes();
          this.postPedidoLineaCesta(this.pedido!, articulo);
        },
        error: (err) => this.handleErrorAux(err, true),
        complete: () => {
          this.cestaAnimationStatus = 'initial';
          this.enviando = false;
          this.totalizaSubject.next('consulta');
        }
      });
    }
  }
  posCestaLineaReq(art: Articulo): Observable<any> {
    const url = this.SERVER_URL + '/pedlineas';
    return this.http.post(url, art, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN
          ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN')
          : ''
      })
    })
  }

  public postListaLinea(articulo: Articulo): void {
    const url = this.SERVER_URL + '/listalineas';

    if (this.pedidoLista === undefined) {
      this.pedidoLista = {
        pedcc_id: null,
        cli_id: parseInt(this.paramPedido.cli_id, 10),
        alm_id: this.storageService.getItem('alm_id') != null ? parseInt(this.storageService.getItem('alm_id')!, 10) : -1,
        estado: 'X',
        tar_id: null,
        codigo: null,
        sucursal: null,
        razon_social: null,
        nom_comerc: null,
        dir_etiqueta: null,
        cod_postal: null,
        pobl_id: null,
        titulo: null,
        fecha_pedido: null,
        fecha_alta: null,
        fecha_estado: null,
        fecha_precios: null,
        fecha_servicio: null,
        referencias: null,
        bultos: null,
        imp_fac_neto: null,
        imp_fac_total: null,
        notas: null,
        descuentos: [],
        ofertas: [],
        impuestos: [],
        lineas: [],
        imp_portes: 0,
        incid_id: null
      };

      this.postPedido(this.pedidoLista).subscribe({
        next: (res: any) => {
          const resultado = res.resultado[0];
          this.pedidoLista = resultado;
          this.usuario!.pedcc_lista_id = this.pedidoLista!.pedcc_id!;
          this.grabaUsuario();
          this.inicializaParametrosUsu();
        },
        error: (err) => this.handleErrorAux(err, true),
        complete: () => this.postListaLinea(articulo)
      });

    } else {
      if (articulo.lista_pedcc_id == null) {
        articulo.lista_pedcc_id = this.pedidoLista.pedcc_id!;
      }

      articulo.lista = 'true';

      this.http.post(url, articulo, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: environment.AUTH_TOKEN
            ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN')
            : ''
        })
      }).subscribe({
        next: (res: any) => {
          const resultado = res[0];
          this.copiaPedidoPedcc(this.pedidoLista!, resultado);
          this.postPedidoLineaLista(this.pedidoLista!, articulo);
        },
        error: (err) => this.handleErrorAux(err, true),
        complete: () => {
          if (articulo.lista_cant_ped > 0) {
            this.toastr.success('Producto añadido a la lista de favoritos', 'Favoritos');
          } else {
            this.toastr.info('Producto quitado de la lista de favoritos', 'Favoritos');
          }
          this.enviando = false;
        }
      });
    }
  }


  postPedidoLineaCesta(pedido: Pedido, articulo: Articulo) {
    let artEncontrado = false;
    pedido.lineas.forEach(linea => {
      if (articulo.art_id === linea.art_id) {
        // copia sobre articulo nuevos datos ...
        this.copiaArticuloPedcl(articulo, linea);
        artEncontrado = true;
      }
      if (artEncontrado) {
        let index = this.cesta.findIndex(x => x.art_id === linea.art_id);
        if (index === -1) {
          this.cesta.push(linea);
        } else {
          this.copiaArticuloPedcl(this.cesta[index], linea);
        }
        // actualizar en la cesta todos las lineas modificadas
        // actualizar lista de articulos
        index = this.articuloService.articulos.findIndex(x => x.art_id === linea.art_id);
        if (index > -1) {
          this.copiaArticuloPedcl(this.articuloService.articulos[index], linea);
        }
        // return en forEach= continue en for
        return;
      }
    });
    if (!artEncontrado) {
      let index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      this.cesta.splice(index, 1);
      index = this.articuloService.articulos.findIndex(x => x.art_id === articulo.art_id);
      if (index > -1) {
        this.copiaArticuloPedcl(this.articuloService.articulos[index], articulo);
      }
      // index = this.articuloService.articulos.findIndex(x => x.art_id === articulo.art_id);
      // this.copiaArticuloPedcl(this.articuloService.articulos[index], articulo);
    }
    /* if (pedido.lineas.length > 0) {
      if (articulo.art_id === pedido.lineas[0].art_id) {
        this.copiaArticuloPedcl(articulo, pedido.lineas[0]);
      }
      let index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      if (index === -1) {
        this.cesta.push(articulo);
      } else {
        this.copiaArticuloPedcl(this.cesta[index], articulo);
      }
      index = this.articuloService.articulos.findIndex(x => x.art_id === articulo.art_id);
      if (index > -1) {
        this.copiaArticuloPedcl(this.articuloService.articulos[index], articulo);
      }
    } else {
      let index = this.cesta.findIndex(x => x.art_id === articulo.art_id);
      this.cesta.splice(index, 1);
      index = this.articuloService.articulos.findIndex(x => x.art_id === articulo.art_id);
      this.copiaArticuloPedcl(this.articuloService.articulos[index], articulo);
    } */

  }
  postPedidoLineaLista(pedido: Pedido, articulo: Articulo) {
    if (pedido.lineas.length > 0) {
      const linIndex = pedido.lineas.findIndex(x => x.art_id === articulo.art_id);
      const index = this.lista.findIndex(x => x.art_id === articulo.art_id);
      if (index === -1) {
        // añadir
        articulo.lista_pedcl_id = pedido.lineas[linIndex].pedcl_pedcl_id;
        articulo.lista_fecha_estado = pedido.lineas[linIndex].pedcl_fecha_estado;
        this.lista.push(articulo);
      } else {
        // quitar ????
        this.lista.splice(index, 1);
        articulo.lista_pedcl_id = null;
      }
    } else {
      const index = this.lista.findIndex(x => x.art_id === articulo.art_id);
      this.lista.splice(index, 1);
    }
  }
  public putPedidoLinea(articulo: Articulo) {
    const url = this.SERVER_URL + '/pedlineas';
    this.http.put(url,
      articulo, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
        // Authorization''
      })
    }).subscribe(
      (res: any) => {
        // consultar pedido??? y lineas para actualizar info???
      },
      err => this.handleErrorAux(err, true),
      () => this.totalizaCesta()
    );
  }
  public deletePedidoLinea(pedido: Pedido) {
    const url = this.SERVER_URL + '/pedlineas';
    return this.http.post(url,
      pedido, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
        // Authorization''
      })
    });
  }
  getPedidos() {
    this.getPedido().subscribe({
      next: res => {
        console.log('Pedido recibido:', res);
      },
      error: err => {
        console.error('Error al obtener pedido:', err);
      }
    });
    this.getLista().subscribe({
      next: (res) => {
        console.log('Pedido lista recibido:', res);
      },
      error: (err) => {
        console.error('Error al obtener la lista de pedidos:', err);
      }
    });

    this.getPedidoArticulos();
    this.getListaArticulos();
  }

  getPedido(): Observable<PedidoRes> {
    this.pedido = undefined;

    return this.pedidoHttpGet(this.paramPedido).pipe(
      tap(res => {
        if (res.resultado.length > 0) {
          this.pedido = res.resultado[0];

          if (this.pedido != null && this.pedido.fecha_precios != null) {
            const hoyYymmdd = fechaYymmdd(new Date());
            const fprecios = fechaYymmdd(this.pedido.fecha_precios!);

            if (this.pedido.estado === 'W' && fprecios < hoyYymmdd) {
              this.buscaCambioPrecio();
            }
          }
        } else if (this.usuario != undefined) {

          this.usuario.pedcc_id = -1;
          this.inicializaParametrosUsu(false);
        }
      }),
      catchError(err => {
        this.handleErrorAux(err, true);
        return throwError(() => err);
      }),
      finalize(() => console.log('ARTICULOS - HTTP request completed.'))
    );
  }
  buscaCambioPrecio() {
    const toastConf: Partial<IndividualConfig> = {
      disableTimeOut: true,
      closeButton: true,
    };
    const pedido$ = this.putCambioPrecio(this.pedido!)
      .subscribe(
        (res: any) => {
          this.nuevosPrecios = res.items; // array de articulos con cambio de precio
          if (this.nuevosPrecios !== undefined && this.nuevosPrecios.length > 0) {
            this.toastr.success('Ha habido cambio de precios en algunos productos', 'Documento');
            this.nuevosPrecios.forEach((item: { descripcion: string; pvp_anterior: string; pvp: string; }) => {
              this.toastr.info(item.descripcion + ' de ' + item.pvp_anterior + ' a ' + item.pvp, 'Cambio de precio', toastConf);
            });
          }
        }
      );
  }
  getPedidoFechaServicio(): Observable<string> | null {
    if (this.paramPedido === undefined || this.paramPedido.pedcc_id === null || this.paramPedido.pedcc_id === '') {
      return null;
    }
    const fServicio$ = this.fechaServicioHttpGet(Number(this.paramPedido.pedcc_id));
    return fServicio$;
  }
  fechaServicioHttpGet(pedcc_id: number): Observable<any> {
    const url: string = this.SERVER_URL + `/pedido/${pedcc_id}/fechaServicio`;
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
      }),
    });
  }
  getPedidoLineas(): Observable<PedidoLineas> {
    return this.pedidoLineasHttpGet(this.paramPedido).pipe(
      tap(res => {
        this.cestaLineas = res.items ?? [];
      }),
      catchError(err => {
        this.handleErrorAux(err, true);
        return throwError(() => err);
      }),
      finalize(() => console.log('ARTICULOS - HTTP request completed.'))
    );
  }

  getPedidoArticulos(): void {
    if (this.paramPedido.pedcc_id === null || this.paramPedido.pedcc_id === '') {
      this.cesta = [];
      return;
    }

    this.articuloService.getPedidoArticulos().subscribe({
      next: (res) => {
        this.cesta = [];
        if (res.items != null)
          res.items.forEach((articulo) => this.cesta.push(articulo));
        // this.totalizaCesta(); // descomenta si lo necesitas
      },
      error: (err) => this.handleErrorAux(err, true),
      complete: () => console.log('CESTA-ARTICULOS- HTTP request completed.')
    });
  }


  getLista(): Observable<PedidoRes> {
    return this.pedidoHttpGet(this.paramLista).pipe(
      tap((res: PedidoRes) => {
        if (res.resultado.length > 0) {
          this.pedidoLista = res.resultado[0];
        } else if (this.usuario != undefined) {
          this.usuario.pedcc_lista_id = -1;
          this.inicializaParametrosUsu(false);
        }
      }),
      catchError(err => {
        this.handleErrorAux(err, true);
        return throwError(() => err);
      }),
      finalize(() => console.log('ARTICULOS - HTTP request completed.'))
    );
  }



  getListaArticulos(): void {
    if (this.paramLista.pedcc_id === null || this.paramLista.pedcc_id === '') {
      this.lista = [];
      return;
    }

    this.articuloService.getListaArticulos().subscribe({
      next: (res) => {
        this.lista = [];
        if (res.items != undefined)
          res.items.forEach((articulo) => this.lista.push(articulo));
      },
      error: (err) => this.handleErrorAux(err, true),
      complete: () => console.log('LISTA-ARTICULOS- HTTP request completed.')
    });
  }


  pedidoHttpGet(parametro: Parametro): Observable<PedidoRes> {
    return this.coleccionHttpGet(this.SERVER_URL + '/pedido', parametro);
  }
  pedidoLineasHttpGet(parametro: Parametro): Observable<PedidoLineas> {
    return this.coleccionHttpGet(this.SERVER_URL + '/pedlineas', parametro);
  }
  coleccionHttpGet(url: string, parametro: Parametro): Observable<any> {
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''
        // Authorization''
      }),
      params: {
        pedcc_id: parametro.pedcc_id,
        cli_id: parametro.cli_id
      }
    });
  }

  nuevoParametro(): Parametro {
    return {
      pedcc_id: '',
      cli_id: ''
    };
  }

  handleErrorAux(error: HttpErrorResponse, logout: boolean) {

    if (logout) {
      console.warn("STATUS: " + error.status);
      // console.clear(); // Comentado para debug
    } else {
      // Verificamos si estamos en el navegador antes de usar ErrorEvent
      if (isPlatformBrowser(this.platformId)) {
        // console.clear(); // Comentado para debug
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        }
      } else {
        // console.clear(); // Comentado para debug
        // Handle SSR error (en el servidor, no usamos ErrorEvent)
        console.error(
          `Backend returned code ${error.status}, body was: ${error.error}`
        );
      }
    }

  }

}

interface Parametro {
  pedcc_id: string;
  cli_id: string;
}

interface PedidoRes {
  resultado: Pedido[];
}
